const CHIP_CLASSES = {
  hot: "chip-hot",
  warm: "chip-warm",
  nurture: "chip-nurture",
  cold: "chip-cold",
};

export function ScoreChip({ temperature, score }) {
  const cls = CHIP_CLASSES[temperature] || CHIP_CLASSES.cold;
  const label = temperature.charAt(0).toUpperCase() + temperature.slice(1);
  return (
    <span className={`chip ${cls}`} data-testid={`score-chip-${temperature}`}>
      <span className="uppercase tracking-widest text-[10px]">{label}</span>
      <span className="tabular-nums">{Math.round(score)}</span>
    </span>
  );
}
